import request from '@/utils/requset'

// 文章列表
export function articles(data) {
  return request({
    url: `h5/article/lists`,
    method: 'post',
    data: data
  })
}

// 建筑作品公开列表
export function architectures(data) {
  return request({
    url: `h5/model_objects/public/index`,
      method: 'get',
      params: data
  })
} 